import { BasicBooking } from '../../common/graphql/fragments/gql/BasicBooking';
import { isBookingEditable } from '../update-form/utils/bookingUtils';

export const shouldShowOptionalEns = (booking: BasicBooking) => {
  return isBookingEditable(booking) || booking.importReference.ensConfirmed;
};
